import { authedPost, authedPut, authedGet, authedDelete } from '../lib/util/http'
import { AVProject, Approver } from '../types/entities'

export const createProject = async (project: AVProject) => {
  const result = await authedPost(`av/projects`, project)
  const json = await result.json()
  console.error('createProject result - update routeToPath: ', json)
  //routeToPath(`/?page=professional_details&id=${professionalId}`)
}

export const updateProject = async (project: AVProject) => {
  //console.log('project', project)
  const result = await authedPut(`av/projects/${project.ID}`, project)
  const json = await result.json()
  console.error('updateProject result - update routeToPath: ', json)
  //routeToPath(`/?page=professional_details&id=${professionalId}`)
}

export const loadProfessional = async (id: string) => {
  const result = await authedGet(`av/professionals/${id}`)
  const json = await result.json()
  //console.log(json)
  return json.data
}

export const loadProject = async (id: string) => {
  const result = await authedGet(`av/projects/${id}`)
  const json = await result.json()
  //console.log(json)
  return json.data
}

export const loadUsers = async () => {
  const result = await authedGet(`av/users`)
  const json = await result.json()
  return json.data
}

export const createUser = async (user: Approver) => {
  const result = await authedPost(`av/users`, user)
  return await result.json()
}

export const deleteUser = async (userId: string) => {
  const result = await authedDelete(`av/users/${userId}`, {})
  const json = await result.json()
  return json.data
}
